import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Grid from '@material-ui/core/Grid';
import i18n from 'react-intl-universal';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import SearchableSelect from '../../../../components/SearchableSelect';

export default ({ ...props }) => {
  const { classes } = props;
  const defaultRegion = props.regions.filter(
    region => region.id === props.selectedRegion
  );
  const defaultArea = props.areas.filter(
    area => area.id === props.selectedArea
  );
  const defaultTerritory = props.territories.filter(
    territory => territory.id === props.selectedTerritory
  );

  return (
    <List component="div" disablePadding>
      <Divider />
      <ListItem>
        <Grid container spacing={8}>
          <Grid item xs={4}>
            <Typography align={'left'} className={classes.typography}>
              {i18n.get('app.dashboard.sidebar.areaOfInterest.cluster')}
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <SearchableSelect
              inputId={'region'}
              defaultValue={
                defaultRegion.length && {
                  value: defaultRegion[0].id,
                  label: defaultRegion[0].name
                }
              }
              options={props.regions.map(region => {
                return {
                  value: region.id,
                  label: region.name
                };
              })}
              actionOnSelectedOption={props.actionOnSelectedRegion}
              isDisabled={!props.regions.length}
              limit={5}
              placeholder={i18n.get(
                'app.dashboard.sidebar.areaOfInterest.cluster'
              )}
            />
          </Grid>
        </Grid>
      </ListItem>
      <Divider />
      <ListItem>
        <Grid container spacing={8}>
          <Grid item xs={4}>
            <Typography align={'left'} className={classes.typography}>
              {i18n.get('app.dashboard.sidebar.areaOfInterest.area')}
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <SearchableSelect
              inputId={'area'}
              defaultValue={
                defaultArea.length && {
                  value: defaultArea[0].id,
                  label: defaultArea[0].name
                }
              }
              options={props.areas.map(area => {
                return {
                  value: area.id,
                  label: area.name
                };
              })}
              actionOnSelectedOption={props.actionOnSelectedArea}
              isDisabled={!props.areas.length}
              limit={5}
              placeholder={i18n.get(
                'app.dashboard.sidebar.areaOfInterest.area'
              )}
            />
          </Grid>
        </Grid>
      </ListItem>
      <Divider />
      <ListItem>
        <Grid container spacing={8}>
          <Grid item xs={4}>
            <Typography align={'left'} className={classes.typography}>
              {i18n.get('app.dashboard.sidebar.areaOfInterest.thana')}
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <SearchableSelect
              inputId={'territory'}
              defaultValue={
                defaultTerritory.length && {
                  value: defaultTerritory[0].id,
                  label: defaultTerritory[0].name
                }
              }
              options={props.territories.map(territory => {
                return {
                  value: territory.id,
                  label: territory.name
                };
              })}
              actionOnSelectedOption={props.actionOnSelectedTerritory}
              isDisabled={!props.territories.length}
              limit={5}
              placeholder={i18n.get(
                'app.dashboard.sidebar.areaOfInterest.thana'
              )}
            />
          </Grid>
        </Grid>
      </ListItem>
    </List>
  );
};
